import { AppForm } from '../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ContractorAppEntityContractorWrite
} from '../../../../../../openapi';
import { ContractorTag } from '../contractor-data-section.component';

@Injectable()
export class ContractorDataForm extends AppForm {
  constructor() {
    super({
      dataSameAsApplicant: new FormControl(false, { nonNullable: true }),
      contractors: new FormControl([], { nonNullable: true })
    });
  }

  public get dataSameAsApplicant(): FormControl {
    return this.get('dataSameAsApplicant') as FormControl;
  }

  public dataSameAsApplicantChange(v: boolean): void {
    if (!v) {
      this.contractors.setValidators([Validators.required, Validators.minLength(1)]);
    } else {
      this.contractors.setValidators([]);
    }
    this.contractors.setValue([]);
  }

  public get contractors(): FormControl {
    return this.get('contractors') as FormControl;
  }

  public get contractorsValues(): ContractorAppEntityContractorWrite[] {
    return this.contractors.value;
  }

  public addContractorItem(value: ContractorAppEntityContractorWrite): void {
    this.contractors.setValue([...this.contractorsValues, value]);
  }

  public editContractorItem(index: number, value: ContractorAppEntityContractorWrite): void {
    const v = [...this.contractorsValues];
    v[index] = value;
    this.contractors.setValue(v);
  }

  public removeContractorItem(index: number): void {
    this.contractors.setValue(this.contractorsValues.filter((_, i) => i !== index));
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead, tag?: ContractorTag) {
    if (!tag) {
      super.patchFormValues({
        dataSameAsApplicant: !!value?.investorDataSameAsApplicant
      });
    } else {
      switch (tag) {
        case 'performer': {
          this.dataSameAsApplicant.setValue(!!value?.performerDataSameAsApplicant);
          this.dataSameAsApplicantChange(!!value?.performerDataSameAsApplicant);
          break;
        }
        case 'investor': {
          this.dataSameAsApplicant.setValue(!!value?.investorDataSameAsApplicant);
          this.dataSameAsApplicantChange(!!value?.investorDataSameAsApplicant);
          break;
        }
      }
    }
  }

  public toWriteModel(tag?: ContractorTag): ApplicationAppEntityApplicationWrite {
    if (!tag) {
      return {
        investorDataSameAsApplicant: this.dataSameAsApplicant.value
      };
    } else {
      switch (tag) {
        case 'performer': {
          return {
            performerDataSameAsApplicant: this.dataSameAsApplicant.value
          };
        }
        case 'investor': {
          return {
            investorDataSameAsApplicant: this.dataSameAsApplicant.value
          };
        }
      }
    }
  }
}
